import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { useToggle } from 'usehooks-ts';

export const AutoForceOutPlanActionsCell = (props: {
  onReprocess: () => void;
  planCorrelationId: string;
  planDescription: string;
  reprocessableCount: number;
}) => {
  const [isReprocessOpen, toggleReprocessOpen] = useToggle();

  const onConfirmReprocess = () => {
    toggleReprocessOpen();
    props.onReprocess();
  };

  return (
    <>
      <ActionMenu
        actions={[
          {
            content: 'Reprocess plan',
            disabled: !props.reprocessableCount,
            onSelect: toggleReprocessOpen
          }
        ]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actionsAutoForceOutPlan-${props.planCorrelationId}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      {isReprocessOpen && (
        <ConfirmationDialog
          confirmText='Reprocess plan'
          data-testid={`reprocessAutoForceOutPlan-${props.planCorrelationId}`}
          isOpen={isReprocessOpen}
          message={`This clears the stall on ${props.reprocessableCount} stalled or system-canceled candidates on ${props.planDescription} and resets their failed attempt counts. Candidates canceled by an admin are left alone. The nightly force out jobs will retry them on their next run.`}
          onCancel={toggleReprocessOpen}
          onConfirm={onConfirmReprocess}
          title='Reprocess Plan Force Out Candidates'
        />
      )}
    </>
  );
};
